import { makeLimitedListActions } from 'utils/factory'
import { accountNotificationsListener } from 'utils/services/notificationsService'

import * as atypes from '../filterReduxActionTypes'

const baseListActions = makeLimitedListActions('segments', { withoutHash: true })
export const fetchSegments = baseListActions.fetch
export const dropSegments = baseListActions.drop
export const segmentCreatedNotification = baseListActions.createdNotification
export const segmentUpdatedNotification = baseListActions.updatedNotification
export const segmentDeletedNotification = baseListActions.deletedNotification

export const updateSegmentCounter = (data) => ({
  type: atypes.SEGMENT_COUNTER_CHANGED,
  data,
})

accountNotificationsListener.on('segment_updated', (data, dispatch) => {
  dispatch(segmentUpdatedNotification(data.model))
})
accountNotificationsListener.on('segment_counter_updated', (data, dispatch) => {
  dispatch(updateSegmentCounter(data))
})
accountNotificationsListener.on('segment_deleted', (data, dispatch) => {
  dispatch(segmentDeletedNotification(data.id))
})
accountNotificationsListener.on('segment_created', (data, dispatch) => {
  dispatch(segmentCreatedNotification(data.model))
})
